import React, {
  createContext,
  PropsWithChildren,
  useEffect,
  useReducer,
  useState,
} from "react";
import {
  RouteAction,
  RoutesActionTypes,
  routesDataReducer,
  routesInitialState,
  RoutesState,
} from "./reducer";
import { routesService } from "@/services/routes";
import { useAuth } from "../AuthContext";

export const routeContext = createContext<{
  routes: RoutesState;
  dispatch: <T = any>(action: RouteAction<T>) => void;
  handleReload: () => void;
  loading: boolean;
}>({
  routes: routesInitialState,
  dispatch: () => null,
  handleReload: () => null,
  loading: false,
});

const RoutesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(routesDataReducer, routesInitialState);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    if(!token) return;
    setLoading(true);

      routesService
        .getRoutes()
        .then((routes) => {
          dispatch({
            type: RoutesActionTypes.LOAD_ROUTES,
            payload: routes,
          });
        })
        .catch((error) => {
          console.error("Hereee : Error fetching routes:", error);
        }).finally(() => {
          setLoading(false);
        });
  }, [token, reload]);

  return (
    <routeContext.Provider
      value={{
        loading,
        routes: state,
        dispatch,
        handleReload,
      }}
    >
      {children}
    </routeContext.Provider>
  );
};

export default RoutesProvider;
